import gql from 'graphql-tag';

export const createOrganizationPaymentsReport = gql`mutation createOrganizationPaymentsReport($createOrganizationPaymentsReportMutation: createOrganizationPaymentsReportInput!) {
  createOrganizationPaymentsReport(input: $createOrganizationPaymentsReportMutation) {
    classpayReport {
      success
    }
  }
}`;
